module.exports = __webpack_public_path__ + "static/media/logo-rtl.d9bf041d.svg";